export default "__VITE_PUBLIC_ASSET__425dda45__"